<template>
  <div>
    <list v-show="showList" ref="listComponent" @onEdit="handleEdit"></list>
    <edit v-if="!showList" :record="record" @onGoBack="handleGoBack"></edit>
  </div>
</template>

<script>
import '@/assets/css/booking.css'
// 动态切换组件
import List from './BookList'
import Edit from './BookEdit'

export default {
  name: 'BookPage',
  components: {
    List,
    Edit
  },
  data () {
    return {
      record: '',
      // 是否显示List
      showList: true
    }
  },
  mounted () {
  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.showList = false
    },
    handleGoBack () {
      this.record = ''
      this.$refs.listComponent.refreshCurrentPage()
      this.showList = true
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.showList = true
    }
  }
}
</script>
<style lang="less">

</style>
